import { render } from "./NewMessageForm.vue?vue&type=template&id=10f774d9&scoped=true"
import script from "./NewMessageForm.vue?vue&type=script&lang=js"
export * from "./NewMessageForm.vue?vue&type=script&lang=js"

import "./NewMessageForm.vue?vue&type=style&index=0&id=10f774d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f774d9"]])

export default __exports__